import axios from 'axios';
import authHeader from "@/service/auth-header";

class PhoneCallService {

    getCompanyPhoneCalls(companyId) {
        return axios.get(`/api/phonecall/${companyId}`, {headers: authHeader()})
    }

    getPhoneCall(phoneCallId) {
        return axios.get(`/api/phonecall/specific/${phoneCallId}`, {headers: authHeader()})
    }

    createPhoneCall(companyId, data) {
        return axios.post(`/api/phonecall/${companyId}`, data, {headers: authHeader()});
    }

    updatePhoneCall(phoneCallId, data) {
        return axios.put(`/api/phonecall/${phoneCallId}`, data, {headers: authHeader()});
    }

    deletePhoneCall(phoneCallId) {
        return axios.delete(`/api/phonecall/${phoneCallId}`, {headers: authHeader()});
    }

}

export default new PhoneCallService();
